module.exports = __webpack_public_path__ + "static/media/suez_logo.90b65e8b.png";